const stepperData = ["施設情報・職員情報", "届出内容確認", "機構へ提出"];
const infoHeadTitleList: any[] = [
  {
    headTitle: "施設名称",
    helpText: (
      <>
        施設・事業所の正式な名称です。
        <br />
        指定通知、許認可書又は定款等で定められている施設の名称と異なる場合は、修正をしてください。
      </>
    ),
  },
  {
    headTitle: "施設種類",
    helpText: "登録する施設・事業の施設種類・サービス種類です。",
  },
  {
    headTitle: "施設区分",
    helpText: (
      <>
        施設種類・サービス種類に応じた施設区分を表示しています。
        <br />
        施設区分に応じて掛金が変わります。
        <br />
        詳しくは
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫施設区分について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    headTitle: "入所定員（利用定員）",
    helpText:
      "法令上定められた基準数（許認可・届出書記載事項）を入力してください。なお、国の指定がない施設・事業の場合は「0」とします。",
  },
  {
    headTitle: "職員配置基準数",
    helpText:
      "法令上定められた基準数（許認可・届出書記載事項）を入力してください。なお、国の指定がない施設・事業の場合は「0」とします。",
  },
  {
    headTitle: "申込時職員総数",
    helpText: (
      <>
        加入対象の職員と加入対象外の職員を合わせた申込時の当該施設の職員総数です。
        <br />
        ※加入要件については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    headTitle: "加入職員数",
    helpText: (
      <>
        加入対象の職員数です。職員名簿に記載いただく職員の人数と同一です。
        <br />
        ※加入要件については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    headTitle: "雇用期間1年未満職員数",
    helpText: (
      <>
        雇用期間が１年未満の加入対象外となる職員数です。
        <br />
        ※加入要件については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    headTitle: "労働時間2/3未満職員数",
    helpText: (
      <>
        労働時間が正職員の週の所定労働時間の2/3未満の加入対象外となる職員数です。
        <br />
        ※加入要件については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫加入要件について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
      </>
    ),
  },
  {
    headTitle: "当該施設・事業を経営している証拠書類",
  },
];

export { stepperData, infoHeadTitleList };
